// components
import { ControlledAutoComplete } from 'components/shared/ControlledFields';
import {
  GridCompact6,
  GridContainer
} from 'components/shared/Grid/Grid.components';

// constants
import { FILTER_POPOVER_WIDTH } from 'components/flex-portal/FlexMatch/components/FilterPopper.consts';

// hooks
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// styles
import { StyledAddRowMotionBoxNoPaddingColumns } from 'components/flex-portal/FlexMatch/components/FlexMatchFilters.styles';
import {
  StyledFilterSectionTypography,
  StyledFilterSectionWithMarginTopTypography
} from './RosterPlanFilters.styles';

// types
import type { RosterPlanFilter } from '../RosterPlan.types';

// utils
import { AnimatePresence } from 'motion/react';

export const RosterPlanFilters = ({
  filters,
  showMoreFilters = false
}: {
  filters: RosterPlanFilter[];
  showMoreFilters?: boolean;
}) => {
  const { t } = useTranslation('common', { keyPrefix: 'rosterPlan' });
  const { control } = useFormContext();

  const employeesFilters = filters.filter((f) => !f.section);

  const openRequestFilters = filters.filter(
    (f) => f.section?.includes('openRequests')
  );

  return (
    <>
      <GridContainer spacing={3} maxWidth={FILTER_POPOVER_WIDTH}>
        <StyledFilterSectionTypography variant="body2">
          {t('filters.rosterSectionTitle')}
        </StyledFilterSectionTypography>
        {employeesFilters?.map((filter) => (
          <GridCompact6 key={filter.key}>
            <ControlledAutoComplete
              disableSorting
              optionLabelProp="label"
              idProperty="id"
              variant="outlined"
              control={control}
              name={filter.key}
              label={t(`filters.${filter.key}`)}
              options={filter?.options ?? []}
              multiple
              limitTags={2}
              fullWidth
            />
          </GridCompact6>
        ))}
      </GridContainer>

      <AnimatePresence initial={false}>
        {showMoreFilters && (
          <StyledAddRowMotionBoxNoPaddingColumns key="motion-show-more-filters">
            <StyledFilterSectionWithMarginTopTypography variant="body2">
              {t('filters.openRequestsSectionTitle')}
            </StyledFilterSectionWithMarginTopTypography>
            <GridContainer spacing={3} maxWidth={FILTER_POPOVER_WIDTH}>
              {openRequestFilters?.map((filter) => (
                <GridCompact6 key={filter.key}>
                  <ControlledAutoComplete
                    disableSorting
                    optionLabelProp="label"
                    idProperty="id"
                    variant="outlined"
                    control={control}
                    name={filter.key}
                    label={t(`filters.${filter.label}`)}
                    options={filter?.options ?? []}
                    multiple
                    limitTags={2}
                    fullWidth
                  />
                </GridCompact6>
              ))}
            </GridContainer>
          </StyledAddRowMotionBoxNoPaddingColumns>
        )}
      </AnimatePresence>
    </>
  );
};
